export default function SurvivorSwarmIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#5DB84A" />
      <circle cx="32" cy="34" r="17" fill="#C6F28A" opacity="0.55" />
      <path d="M10 22c0-6 10-6 10 0v3H10z" fill="#6BD66B" stroke="#1E3A1E" strokeWidth="1.8" />
      <path d="M44 50c0-6 10-6 10 0v3H44z" fill="#6BD66B" stroke="#1E3A1E" strokeWidth="1.8" />
      <circle cx="52" cy="16" r="6" fill="#A07CFF" stroke="#2A1E50" strokeWidth="1.8" />
      <path d="M8 46c0-7 12-7 12 0v6H8z" fill="#FF6B6B" stroke="#4A1E1E" strokeWidth="1.8" />
      <circle cx="32" cy="36" r="8" fill="#2F8BFF" stroke="#163E7A" strokeWidth="2" />
      <path d="M24 30h16l-8-14z" fill="#7B3FE4" />
      <path d="M44 28l2.2 4.6 5 .7-3.6 3.5.9 5-4.5-2.4-4.5 2.4.9-5-3.6-3.5 5-.7z" fill="#FFD84D" stroke="#E8A020" strokeWidth="1.2" />
      <path d="M18 34l3 5-3 5-3-5z" fill="#4DB8FF" />
      <path d="M48 42l2.4 4-2.4 4-2.4-4z" fill="#5BE36B" />
    </svg>
  );
}
